import moment from 'moment';

const timeFormat = 'HH:mm';

export default {
  methods: {
    generateEmptySettings() {
      return {
        playlist_id: null,
        loop_playlist_id: null,
        playlist: null,
        // volume: 0, // 0 - 100
        // rotation: 0, // 0 90 180 270
        check_interval: 10, // in seconds
        business_hours: this.extendBusinessHours({ business_hours: {} }), // ['HH:ss', 'HH:ss']
        play_old: 1,
        active: 0,
      };
    },
    flattenBusinessHours(settingsObject) {
      const arrayBh = settingsObject.business_hours;
      const futureBhObject = {};
      arrayBh.forEach((dayObject) => {
        if (dayObject.active && dayObject.hoursStart && dayObject.hoursEnd) {
          futureBhObject[String(dayObject.dayNo)] = [
            moment(dayObject.hoursStart, moment.ISO_8601).format(timeFormat),
            moment(dayObject.hoursEnd, moment.ISO_8601).format(timeFormat),
          ];
        }
      });
      return futureBhObject;
    },
    extendBusinessHours(settingsObject) {
      const flatBh = settingsObject.business_hours;
      const futureBhArray = [
        {
          active: false,
          dayNo: 1,
          day: 'Mon',
          hoursStart: moment('07:00', timeFormat).toISOString(),
          hoursEnd: moment('20:00', timeFormat).toISOString(),
        },
        {
          active: false,
          dayNo: 2,
          day: 'Tue',
          hoursStart: moment('07:00', timeFormat).toISOString(),
          hoursEnd: moment('20:00', timeFormat).toISOString(),
        },
        {
          active: false,
          dayNo: 3,
          day: 'Wed',
          hoursStart: moment('07:00', timeFormat).toISOString(),
          hoursEnd: moment('20:00', timeFormat).toISOString(),
        },
        {
          active: false,
          dayNo: 4,
          day: 'Thu',
          hoursStart: moment('07:00', timeFormat).toISOString(),
          hoursEnd: moment('20:00', timeFormat).toISOString(),
        },
        {
          active: false,
          dayNo: 5,
          day: 'Fri',
          hoursStart: moment('07:00', timeFormat).toISOString(),
          hoursEnd: moment('20:00', timeFormat).toISOString(),
        },
        {
          active: false,
          dayNo: 6,
          day: 'Sat',
          hoursStart: moment('07:00', timeFormat).toISOString(),
          hoursEnd: moment('20:00', timeFormat).toISOString(),
        },
        {
          active: false,
          dayNo: 7,
          day: 'Sun',
          hoursStart: moment('07:00', timeFormat).toISOString(),
          hoursEnd: moment('20:00', timeFormat).toISOString(),
        },
      ];
      if (flatBh) {
        Object.keys(flatBh).forEach((flatBhDay) => {
          const parsedDayNumber = Number(flatBhDay);
          const foundDay = futureBhArray.find(day => day.dayNo === parsedDayNumber);
          if (foundDay) {
            foundDay.hoursStart = moment(flatBh[flatBhDay][0], timeFormat).toISOString();
            foundDay.hoursEnd = moment(flatBh[flatBhDay][1], timeFormat).toISOString();
            foundDay.active = true;
          }
        });
      }

      return futureBhArray;
    },
  },
};
